// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e5545399","453":"d2d6f728"}[chunkId] + ".chunk.js";
};